import { makeStyles } from "tss-react/mui";

const useCheckBoxStyles = makeStyles()(() => ({
  grid: {
    display: "flex",
    alignItems: "flex-start",
  },
}));

export default useCheckBoxStyles;
